import { ContentSection } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { PolicyData } from '../types';

interface PropertiesTabContentProps {
    data: PolicyData;
    rightContent?: React.ReactNode;
}

export const TotalPropertiesSection = ({ data, rightContent }: PropertiesTabContentProps) => {
    // potentially overcounted one property can be assigned individually and as part of a property group
    const totalProperties =
        (data.propertyRateGroupCounts?.length ?? 0) +
        (data.propertyGroupRateGroupCounts?.reduce((count, { propertyCount }) => count + propertyCount, 0) ?? 0);
    return (
        <ContentSection
            title={
                <Stack itemAlignment="center">
                    {lt('TotalProperties')}
                    {UnicodeEntity.NoBreakSpace}
                    <Typography textStyle="titleMedium" variant="secondary" as="div">
                        {totalProperties}
                    </Typography>
                </Stack>
            }
            titleSize="medium"
            rightContent={rightContent}
        />
    );
};
